import type { ProductOptionChoice } from "@kanpla/api-contract";

import { type BasketItemVariant } from "../../types";

export type VariantChoiceWithMeta = {
  /** The variant choice with pre-calculated prices from product.options / product.variants */
  choice: ProductOptionChoice;
  quantity: number;
};

/**
 * Maps basket choices to variant data with pre-calculated prices.
 *
 * @param choices - The variant choices from the basket item
 */
export function mapBasketChoicesToVariants(
  choices: BasketItemVariant["choices"],
  productChoices: (ProductOptionChoice & { optionId: string })[]
): Map<string, VariantChoiceWithMeta> {
  const variantMap = new Map<string, VariantChoiceWithMeta>();

  for (const basketChoice of choices) {
    // Find the pre-calculated choice from product.variants
    // 💥 Issue if choice.id is duplicate in the variants array
    const productChoice = productChoices.find(
      (pv) =>
        pv.id === basketChoice.id && pv.optionId === basketChoice.variantId
    );
    if (!productChoice) continue;

    variantMap.set(basketChoice.id, {
      choice: {
        ...productChoice,
        allergens: productChoice.allergens ?? []
      },
      quantity: basketChoice.quantity
    });
  }

  return variantMap;
}
